import React from "react";

const SvgReportingLineMobile = props => (
  <svg className="reporting__line-mobile" viewBox="0 0 257 32" {...props}>
    <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <polygon
        id="Rectangle-Copy-8"
        fill="#009EE3"
        points="0 0 247 0 257 16 247 32 0 32"
      />
      <g
        className="arrow-one reporting__arrow__item reporting__arrow__item_1"
        id="Group-9-Copy-6"
        transform="translate(7.000000, 9.000000)"
        stroke="#FEFEFE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M8,7 L63,7" id="Stroke-1" strokeDasharray="5 5" />
        <path
          d="M4,11 C6.21,11 8,9.208 8,7 C8,4.79 6.21,3 4,3 C1.79,3 0,4.79 0,7 C0,9.208 1.79,11 4,11 Z"
          id="Stroke-3"
        />
        <polyline id="Stroke-5" points="59 0 67 7.00093998 59 14" />
      </g>
      <g
        className="arrow-two reporting__arrow__item reporting__arrow__item_2"
        id="Group-9-Copy-8"
        transform="translate(92.000000, 9.000000)"
        stroke="#FEFEFE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M8,7 L63,7" id="Stroke-1" strokeDasharray="5 5" />
        <path
          d="M4,11 C6.21,11 8,9.208 8,7 C8,4.79 6.21,3 4,3 C1.79,3 0,4.79 0,7 C0,9.208 1.79,11 4,11 Z"
          id="Stroke-3"
        />
        <polyline id="Stroke-5" points="59 0 67 7.00093998 59 14" />
      </g>
      <g
        className="arrow-three reporting__arrow__item reporting__arrow__item_3"
        id="Group-9-Copy-7"
        transform="translate(173.000000, 9.000000)"
        stroke="#FEFEFE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M8,7 L63,7" id="Stroke-1" strokeDasharray="5 5" />
        <path
          d="M4,11 C6.21,11 8,9.208 8,7 C8,4.79 6.21,3 4,3 C1.79,3 0,4.79 0,7 C0,9.208 1.79,11 4,11 Z"
          id="Stroke-3"
        />
        <polyline id="Stroke-5" points="59 0 67 7.00093998 59 14" />
      </g>
    </g>
  </svg>
);

export default SvgReportingLineMobile;




// WEBPACK FOOTER //
// ./frontend/pages/InfographicLanding/ReportingLineMobile.jsx